import React from 'react'
import IconCross from '@kawaui/icons/build/icons/navigation/Cross'
import { nltoBr } from 'helpers/utils/StringUtils'
import { CloseButton, Content, Header, Title, Wrapper } from './style'
import { Props } from './types'

const ModalContent: React.FC<Props> = ({
  children,
  onClose,
  title
}) => (
  <Wrapper>
    <Header>
      <CloseButton onClick={onClose}>
        <IconCross width='24px' height='24px' />
      </CloseButton>
      <Title dangerouslySetInnerHTML={{ __html: nltoBr(title) }} />
    </Header>
    <Content>
      {children}
    </Content>
  </Wrapper>
)

export default ModalContent
